let envUrl,
	envRedirectUri,
	envClientId,
	env = process.env.VUE_APP_API_ENV;

if (env == 'production') {
	envUrl = "https://dashtechprojectapi.azurewebsites.net/api/v1",
	envRedirectUri = "https://project.dashtech.app/";
	envClientId = "a2b8ae0f-282b-4d14-981e-825408371772";
}

if (env == 'staging') {
	envUrl = "https://dashtechprojectapi-staging.azurewebsites.net/api/v1";
	envRedirectUri = "https://dashtechstaging.z5.web.core.windows.net/";
	envClientId = "a2b8ae0f-282b-4d14-981e-825408371772";
}

if (env == 'dev') {
	envUrl = "https://dashtechprojectapi-dev.azurewebsites.net/api/v1";
	envRedirectUri = "https://dashtechdev.z5.web.core.windows.net/";
	envClientId = "a342fb1a-9e1b-4d30-a9d3-e39a0ae0e967";
}

if (env == 'localtunnel') {
	envUrl = "https://cts-dashtech.loca.lt/api/v1";
	envRedirectUri = "http://localhost:8080/";
	envClientId = "a342fb1a-9e1b-4d30-a9d3-e39a0ae0e967";
}

if (env == 'local') {
	envUrl = "http://localhost:7071/api/v1";
	envRedirectUri = "http://localhost:8080/";
	envClientId = "a342fb1a-9e1b-4d30-a9d3-e39a0ae0e967";
}

export default {
	apiUrl: envUrl,
	redirectUri: envRedirectUri,
	clientId: envClientId,
};